import React from "react"
import PropTypes from "prop-types"

const ExternalLinkIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 14 11">
    <path d="M10.5,9.59H1.4V3.24H3.22A8.34,8.34,0,0,1,4.74,1.83h-4a0.7,0.7,0,0,0-.7.71v7.76A0.7,0.7,0,0,0,.7,11H11.2a0.7,0.7,0,0,0,.7-0.71V7.65L10.5,8.81V9.59ZM9.35,4.69v2.5L14,3.53,9.35,0V2.21c-5.64,0-5.64,5.62-5.64,5.62C5.31,5.18,6.29,4.69,9.35,4.69Z" />
  </svg>
)

ExternalLinkIcon.propTypes = {
  style: PropTypes.object
}

export default ExternalLinkIcon



// WEBPACK FOOTER //
// ./src/components/icons/external-link.jsx